import { Injectable } from '@angular/core';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { DomainService } from 'src/app/services/domain/domain.service';
import { LogService } from 'src/app/services/log/log.service';
import { Logtype } from 'src/app/enums/log/logtype.enum';

@Injectable({
  providedIn: 'root'
})
export class TrackService {
  constructor(private _winRef: WindorefService, private _domain: DomainService, private _logService: LogService) {}

  loadTrack() {
    const urlParams = new URLSearchParams(this._winRef.getNativeWindow().location.search);
    if (urlParams.get('account') !== undefined && urlParams.get('account') !== null) {
      const tag = this._winRef.getNativeWindow().document.createElement('script');
      let path = this._winRef.getNativeWindow().location.hostname.replace('https://www.', '').replace('http://www.', '').replace('www.', '');
      const currentDomain = this._domain.getCurrentDomain();
      this._logService.createLog(Logtype.INFO, currentDomain, this.constructor.toString().match(/\w+/g)[1], 'loadTrack');
      if (currentDomain) {
        tag.src = currentDomain.url;
        tag.id = 'pap_x2s6df8d';
        tag.type = 'text/javascript';
        tag.async = false;
        tag.defer = true;
        this._winRef.getNativeWindow().document.getElementsByTagName('head')[0].appendChild(tag);
        tag.onload = () => {
          this.loadPack(currentDomain.papTrack);
        };
      } else {
        this._logService.createLog(
          Logtype.ERROR,
          'pending define track.js for next domain: ' + path,
          this.constructor.toString().match(/\w+/g)[1],
          'loadTrack'
        );
      }
    }
  }

  loadPack(packId) {
    const tag = this._winRef.getNativeWindow().document.createElement('script');
    tag.type = 'text/javascript';
    tag.textContent = 'papTrack(' + packId + ')';
    tag.defer = true;
    tag.async = false;
    this._winRef.getNativeWindow().document.getElementsByTagName('head')[0].appendChild(tag);
  }
}
